import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const http = axios.create({ baseURL: API });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cs_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  // Auth
  register: (data) => http.post("/auth/register", data).then(r => r.data),
  verifyOtp: (data) => http.post("/auth/verify-otp", data).then(r => r.data),
  login: (data) => http.post("/auth/login", data).then(r => r.data),
  me: () => http.get("/auth/me").then(r => r.data),
  selectRole: (role) => http.post("/auth/role", { role }).then(r => r.data),
  // Profiles
  saveStudentProfile: (data) => http.post("/profile/student", data).then(r => r.data),
  saveAmbassadorProfile: (data) => http.post("/profile/ambassador", data).then(r => r.data),
  uploadId: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return http.post("/profile/ambassador/upload-id", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
  },
  saveAvailability: (data) => http.post("/profile/ambassador/availability", data).then(r => r.data),
  getAvailability: () => http.get("/profile/ambassador/availability").then(r => r.data),
  saveBank: (data) => http.post("/profile/ambassador/bank", data).then(r => r.data),
  // Colleges
  listColleges: (params) => http.get("/colleges", { params }).then(r => r.data),
  getCollege: (slug) => http.get(`/colleges/${slug}`).then(r => r.data),
  // Coupons / Conversations
  validateCoupon: (data) => http.post("/coupons/validate", data).then(r => r.data),
  createConversation: (data) => http.post("/conversations", data).then(r => r.data),
  myConversations: () => http.get("/conversations").then(r => r.data),
  getConversation: (id) => http.get(`/conversations/${id}`).then(r => r.data),
  startCall: (id) => http.post(`/conversations/${id}/start-call`).then(r => r.data),
  endCall: (id) => http.post(`/conversations/${id}/end-call`).then(r => r.data),
  // Messages
  sendMessage: (data) => http.post("/messages", data).then(r => r.data),
  listMessages: (cid) => http.get(`/messages/${cid}`).then(r => r.data),
  // Ratings
  submitRating: (data) => http.post("/ratings", data).then(r => r.data),
  // Decisions
  createDecision: (data) => http.post("/decisions", data).then(r => r.data),
  myDecisions: () => http.get("/decisions/my").then(r => r.data),
  // Contact
  submitContact: (data) => http.post("/contact", data).then(r => r.data),
  // Leaderboard
  leaderboard: () => http.get("/leaderboard").then(r => r.data),
  // Admin
  adminStats: () => http.get("/admin/stats").then(r => r.data),
  adminAmbassadors: () => http.get("/admin/pending-ambassadors").then(r => r.data),
  adminVerify: (data) => http.post("/admin/verify-ambassador", data).then(r => r.data),
  adminDecisions: () => http.get("/admin/decisions").then(r => r.data),
  adminUpdateDecision: (id, status) => http.post(`/admin/decisions/${id}/status`, { status }).then(r => r.data),
  adminUsers: () => http.get("/admin/users").then(r => r.data),
  adminBan: (uid, ban) => http.post(`/admin/users/${uid}/ban`, { ban }).then(r => r.data),
  adminContact: () => http.get("/admin/contact-submissions").then(r => r.data),
  adminCoupons: () => http.get("/admin/coupons").then(r => r.data),
  adminCreateCoupon: (data) => http.post("/admin/coupons", data).then(r => r.data),
  seed: () => http.post("/seed").then(r => r.data),
};

export function deviceFingerprint() {
  const s = [navigator.userAgent, screen.width + "x" + screen.height, Intl.DateTimeFormat().resolvedOptions().timeZone, navigator.language].join("|");
  let h = 0;
  for (let i = 0; i < s.length; i++) { h = ((h << 5) - h) + s.charCodeAt(i); h |= 0; }
  return "fp_" + Math.abs(h).toString(16);
}
